module.exports = __webpack_public_path__ + "static/media/whistle.540de4c9.svg";